module.exports = __webpack_public_path__ + "static/iso-removal-512-0ba28e823da006b0e533abf1d7bda906.png";